import { Directive, input } from '@angular/core';

@Directive({
  selector: '[hlmBreadcrumb]',
  host: {
    'data-slot': 'breadcrumb',
    role: 'navigation',
    style:
      '--ocp-breadcrumb-gap: var(--breadcrumb-gap, 0.25rem); font-size: var(--font-size-xs); color: var(--corporate-text-primary)',
    '[attr.aria-label]': 'ariaLabel()',
  },
})
export class HlmBreadcrumb {
  public readonly ariaLabel = input<string>('breadcrumb', { alias: 'aria-label' });
}
